export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export function toSortOrder(value) {
    return Object.values(SortOrder).includes(value) ? value : undefined;
}
